//react
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
//material UI
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  // Select,
  TextField,
  Box,
} from "@mui/material";

//react redux
import { useDispatch, useSelector } from "react-redux";

//slices
import {
  // addAnalysisAndGraphs,
  setConfidenceLevel,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

//functions
import { createAnalysis } from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getChiSquare } from "../../../utils/computation/getChiSquare";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
  maxHeight: "90%",
  overflow: "auto",
};

const VariableInput = ({ value, onChange, inputNumber }) => {
  const titleArray = ["first", "second"];
  return (
    <>
      <h3
        style={{
          marginTop: "10px",
        }}
      >
        Select {titleArray[inputNumber]} column
      </h3>
      <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
        <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
        <Dropdown value={value} onChange={onChange} />
      </FormControl>
    </>
  );
};

const ChiSquareTestModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  const [numberOfColumns, setNumberOfColumns] = useState(2);
  const [selectedColumns, setSelectedColumns] = useState(["", ""]);

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //redux states
  const token = useSelector((state) => state.auth.token);
  const { data, columns, confidenceLevel } = useSelector(
    (state) => state.dataTable
  );

  //functions
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleChangeConfidenceLevel = (value) => {
    dispatch(setConfidenceLevel(value));
  };

  const handleColumnSelectChange = (event, i) => {
    setSelectedColumns((oldArray) => {
      return oldArray.map((item, indexInOldArray) => {
        return indexInOldArray === i ? event.target.value : item;
      });
    });
  };

  const computeTTest = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const columnValuesArr = selectedColumns
      .filter((col) => col !== "") // remove empty values
      .map((col) => getColumnValues(data, col));

    // console.log({ columnValuesArr, confidenceLevel });

    closeMenu();

    // console.log({
    //   arr1: columnValuesArr[0],
    //   arr2: columnValuesArr[1],
    //   confidenceLevel: Number(confidenceLevel),
    // });

    if (columnValuesArr.length > 0) {
      let [anovaResult] = await Promise.all([
        getChiSquare({
          arr1: columnValuesArr[0],
          arr2: columnValuesArr[1],
          confidenceLevel: Number(confidenceLevel),
        }),
      ]);

      const anovaResults = {
        ...anovaResult,
        column: selectedColumns.join(", "),
        title,
      };

      try {
        //update analysis subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          anovaResults
        );
        anovaResults.id = resFromCreateAnalysis.id;
      } catch (error) {
        console.log("error", error);
        return Swal.fire("Error", error.message, "error");
      }
    }

    dispatch(setIsLoading());
  };

  const inputs = [];
  for (let i = 0; i < numberOfColumns; i++) {
    inputs.push(
      <VariableInput
        key={i}
        value={selectedColumns[i]}
        onChange={(e) => handleColumnSelectChange(e, i)}
        inputNumber={i}
        options={columns}
      />
    );
  }

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid
          item
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{
            padding: "10px",
          }}
        >
          <Grid item xs={6} p={1}>
            <h3> Data Range</h3>

            {inputs}
          </Grid>

          <Grid item xs={6} p={1}>
            <h3> Additional Options</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Confidence level
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="Type a number between 0 to 100.0"
              sx={{ mt: 1 }}
              defaultValue={0}
              type="number"
              onChange={(e) => handleChangeConfidenceLevel(e.target.value)}
            />
          </Grid>
        </Grid>

        <div style={{ display: "flex", float: "right" }}>
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => computeTTest()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ChiSquareTestModal;
